import { render, staticRenderFns } from "./newsfeed-component.vue?vue&type=template&id=5093902f&scoped=true&"
import script from "./newsfeed-component.vue?vue&type=script&lang=js&"
export * from "./newsfeed-component.vue?vue&type=script&lang=js&"
import style0 from "./newsfeed-component.vue?vue&type=style&index=0&id=5093902f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5093902f",
  null
  
)

export default component.exports